<template>
  <div>
    <h1 class="page-header">{{ $t('employee.pageTitle') }}</h1>
    <form class="form-horizontal">
      <div class="row">
        <div class="col-md-3">
          <ts-card>
            <ts-card-wrapper>
              <div class="text-center">
                <ts-image-input
                  :file="file"
                  @input="file => (model.photo = file)"
                  :width="175"
                  :height="225"
                  crop
                ></ts-image-input>
                <span class="mt-2">
                  <i>{{ $t('employee.employeePhoto') }}</i>
                </span>
                <div style="color:#cc4946;margin:4px 0 0">{{ errors.first('photo') }}</div>
              </div>

              <div class="m-b-15">
                <label >{{ $t('employee.cardId') }}</label>
                <input
                  type="text"
                  v-model="model.card_id"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('card_id') }"
                />
                <div
                  class="invalid-feedback"
                  v-if="errors.has('card_id')"
                >{{ errors.first('card_id') }}</div>
              </div>

              <div class="m-b-15">
                <label>{{ $t('employee.attendanceId') }}</label>
                <input
                  type="text"
                  v-model.trim="model.fp_serial_card"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('fp_serial_card') }"
                />
                <div
                  class="invalid-feedback"
                  v-if="errors.has('fp_serial_card')"
                >{{ errors.first('fp_serial_card') }}</div>
              </div>

              <div class="m-b-15">
                <label>{{ $t('employee.employeeNameKh') }}</label>
                <input
                  ref="employee_name_kh"
                  type="text"
                  v-model="model.employee_name_kh"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('employee_name_kh') }"
                />
                <div
                  class="invalid-feedback"
                  v-if="errors.has('employee_name_kh')"
                >{{ errors.first('employee_name_kh') }}</div>
              </div>
              <div class="m-b-15">
                <label class="required">{{ $t('employee.employeeNameEn') }}</label>
                <input
                  type="text"
                  v-model="model.employee_name_en"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('employee_name_en') }"
                />
                <div
                  class="invalid-feedback"
                  v-if="errors.has('employee_name_en')"
                >{{ errors.first('employee_name_en') }}</div>
              </div>

              <div class="m-b-15">
                <label class="required">
                  {{ $t('employee.position') }}
                  <i
                    class="fas fa-spinner spin"
                    v-if="!positions.length && ready_fetch"
                  ></i>
                </label>
                <select
                  v-model.number="model.position_id"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('position_id') }"
                >
                  <option value disabled selected style="display: none;">{{ $t('select') }}</option>
                  <option
                    v-for="(position, index) in positions"
                    :key="index"
                    :value="position.position_id"
                  >
                    {{
                    position.position_name_en
                    }}
                  </option>
                </select>
                <div
                  class="invalid-feedback"
                  v-if="errors.has('position_id')"
                >{{ errors.first('position_id') }}</div>
              </div>
              <div class="radio radio-css radio-inline">
                <input type="radio" id="male" v-model="model.sex" value="Male" />
                <label for="male">Male</label>
              </div>
              <div class="radio radio-css radio-inline">
                <input type="radio" id="female" v-model="model.sex" value="Female" />
                <label for="female">Female</label>
              </div>
              <div class="text-danger" v-if="errors.has('sex')">{{ errors.first('sex') }}</div>
            </ts-card-wrapper>
          </ts-card>
        </div>
        <!-- details -->
        <div class="col-md-9">
          <ts-card>
            <ts-card-wrapper>
              <details-template v-model="model" :validation="errors" />
              <nssf-template v-model="model" :validation="errors" />
              <payroll-template v-model="model" :validation="errors" />
              <div class="row">
                <div class="col-md-12 text-right">
                  <ts-button @click="$router.push({ name: 'employee' })">{{ $t('button.cancel') }}</ts-button>
                  <ts-button
                    outline
                    color="primary"
                    class="ml-2"
                    @click.prevent="saveAddNew"
                    :waiting="waiting_new"
                  >{{ $t('button.saveAddNew') }}</ts-button>
                  <ts-button
                    class="btn-primary ml-2"
                    @click.prevent="create"
                    :waiting="waiting"
                  >{{ $t('button.save') }}</ts-button>
                </div>
              </div>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import NssfTemplate from './components/nssf_template'
import DetailsTemplate from './components/detail_template'
import PayrollTemplate from './components/payroll_template'

export default {
  name: 'employee-create',
  components: {
    NssfTemplate,
    DetailsTemplate,
    PayrollTemplate
  },
  data() {
    return {
      model: {
        employee_name_kh: '',
        employee_name_en: '',
        sex: 'Male',
        phone: '',
        card_id: '',
        email: '',
        address: '',
        photo: '',
        position_id: '',
        hire_date: moment().format('DD-MM-YYYY'),
        probation_end_date: moment()
          .add(3, 'M')
          .format('DD-MM-YYYY'),
        status_id: '',
        status_effective_date: '',
        shift_id: '',
        pc_date_id: '',
        payment_type_id: '',
        is_tax_responsed_by_company: false,
        is_spouse_dependant: false,
        num_child_dependant: 0,
        nssf_number: '',
        ssn_no: '',
        ssn_issued_date: '',
        ssn_expiry_date: '',
        ssn_issued_at: '',
        nationality_id: '',
        date_of_birth: '',
        emp_type_id: '',
        status_reason_id: null,
        fp_serial_card: ''
      },
      errors: new Errors(),
      ready_fetch: false,
      waiting: false,
      waiting_new: false,
      file: require('../../../assets/user_default.png')
    }
  },
  computed: {
    ...mapState('hr/employee', ['positions', 'status', 'shifts', 'pcDates', 'paymentTypes'])
  },
  created() {
    this.fetchBeforCreate()
  },
  methods: {
    fetchBeforCreate() {
      this.ready_fetch = true
      this.$store
        .dispatch('hr/employee/dataBeforeCreate')
        .then(response => {
          this.ready_fetch = false
        })
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
    },
    async create() {
      this.errors = new Errors()
      this.waiting = true
      let photo_path = await this.uploadPhoto()
      this.$store
        .dispatch('hr/employee/create', Object.assign({}, this.model, { photo: photo_path }))
        .then(response => {
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'employee' })
        })
        .catch(error => {
          this.waiting = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    async saveAddNew() {
      this.errors = new Errors()
      this.waiting_new = true
      let photo_path = await this.uploadPhoto()
      this.$store
        .dispatch('hr/employee/create', Object.assign({}, this.model, { photo: photo_path }))
        .then(response => {
          this.waiting_new = false
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.waiting_new = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    uploadPhoto() {
      if (this.model.photo instanceof File || this.model.photo instanceof Blob) {
        let formData = new FormData()
        formData.append('photo', this.model.photo)
        return this.$store.dispatch('hr/employee/photoUpload', formData)
      }

      return this.model.photo
    },
    clearInput() {
      this.model.employee_name_kh = '',
      this.model.employee_name_en = '',
      this.model.sex = 'Male',
      this.model.phone = '',
      this.model.card_id = '',
      this.model.email = '',
      this.model.address = '',
      this.model.photo = '',
      this.model.position_id = '',
      this.model.hire_date = moment().format('DD-MM-YYYY'),
      this.model.probation_end_date = moment()
      .add(3, 'M')
      .format('DD-MM-YYYY'),
      this.model.status_id = '',
      this.model.status_effective_date = '',
      this.model.shift_id = '',
      this.model.pc_date_id = '',
      this.model.payment_type_id = '',
      this.model.is_tax_responsed_by_company = false,
      this.model.is_spouse_dependant = false,
      this.model.num_child_dependant = 0,
      this.model.nssf_number = '',
      this.model.ssn_no = '',
      this.model.ssn_issued_date = '',
      this.model.ssn_expiry_date = '',
      this.model.ssn_issued_at = '',
      this.model.nationality_id = '',
      this.model.date_of_birth = '',
      this.model.emp_type_id = '',
      this.model.status_reason_id = null,
      this.model.fp_serial_card = ''
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('hr/employee/RESET_STATE')
    next()
  }
}
</script>

<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  /* border-bottom: 1px solid #eee; */
  font-size: 16px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
</style>
